import { Grid, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import makeStyles from "@mui/styles/makeStyles";
import React, { useCallback, useEffect, useState } from "react";
import FilesDisplayList from "../../Components/FilesDisplayList";
import service from "../../helpers/GifService";
import { useSelector } from "react-redux";
import {
  canEditSelector,
  reportingAsSelector,
} from "../../../../store/applicantsSlice";
import {
  PRE_PROPOSAL_STATUS,
  programTypes,
  PROPOSAL_STATUS,
} from "../../Constants";
import { useLoading } from "../../../../providers/loadingProvider";
import { useConfirm } from "../../../../Contexts/ConfirmContext/ConfirmService";
import { proposalSelector } from "../../../../store/proposalSlice";

//all(pre proposal + proposal)
const ABSTRACT_FILE_NAME = "propabstract";
const SHORT_DESCRIPTION_FILE_NAME = "prepropshortdesc";
//const BUDGET_FILE_NAME = "prepropbudget";
//proposal Files
//regular
const JOINT_PUBLICATION_FILE_NAME = "propjointpub";
//young
const DIPLOMA_FILE_NAME = "propdiploma";
//both programs
const BIBLIOGRAPHY_FILE_NAME = "propbib";
const PROJECT_DESCRIPTION_FILE_NAME = "propdesc";
const ADDITIONAL_MATERIALS_FILE_NAME = "propadditionalmat";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
    display: "inline-block",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const filesData = [
  {
    name: ABSTRACT_FILE_NAME,
    category: "Abstract",
    files: null,
    programs: "all",
    stages: [PROPOSAL_STATUS,PRE_PROPOSAL_STATUS],
  },
  {
    name: PROJECT_DESCRIPTION_FILE_NAME,
    category: "Full Project Description",
    files: [],
    programs: "all",
    stages: [PROPOSAL_STATUS],
  },
  {
    name: JOINT_PUBLICATION_FILE_NAME,
    category: "Joint Publications",
    files: [],
    programs: [programTypes.regularProgram, programTypes.CollaborativeTrack],
    stages: [PROPOSAL_STATUS],
  },
  {
    name: BIBLIOGRAPHY_FILE_NAME,
    category: "Bibliography",
    files: [],
    programs: "all",
    stages: [PROPOSAL_STATUS],
  },
  {
    name: SHORT_DESCRIPTION_FILE_NAME,
    category: "Short project description",
    files: [],
    programs: "all",
    stages: [PRE_PROPOSAL_STATUS],
  },
  {
    name: DIPLOMA_FILE_NAME,
    category: "Diploma",
    files: [],
    programs: [programTypes.youngScientist],
    stages: [PROPOSAL_STATUS],
  },
  {
    name: ADDITIONAL_MATERIALS_FILE_NAME,
    category: "Additional Material",
    files: [],
    programs: "all",
    multiple: true,
    stages: [PROPOSAL_STATUS],
  },
];

export default function UploadDocs() {
  const classes = useStyles();
  const confirm = useConfirm();
  const proposal = useSelector(proposalSelector);
  const loading = useLoading();
  const as = useSelector(reportingAsSelector);
  const canEdit = useSelector(canEditSelector);

  const [files, setFiles] = useState([]);

  const getFiles = useCallback(async () => {
    setFiles([]);
    const loadingId = loading.addLoading("fetching files");
    const proposalId = proposal.id;
    let withFiles = filesData;
    var proposalFiles = await service.getProposalFiles({ proposalId });
    withFiles.forEach((file) => {
      file.files = proposalFiles.filter((f) =>
        f.name.includes(`${proposalId}_${file.name}`)
      );
    });

    withFiles = withFiles.filter(
      (file) =>
        file.stages.length === 0 || file.stages.includes(proposal.status)
    );
    withFiles = withFiles.filter(
      (file) =>
        file.programs === "all" || file.programs.includes(proposal?.programType)
    );
    setFiles(withFiles);
    loading.removeLoading(loadingId);
  }, [loading, proposal]);

  const uploadFile = async ({ file, fileName }) => {
    const loadingId = loading.addLoading("Uploading File");
    service
      .UploadProposalFile({ file, proposalId: proposal.id, fileName })
      .then(() => {
        getFiles();
        loading.removeLoading(loadingId);
      });
  };
  const deleteFile = async ({ fileName }) => {
    const res = await confirm({
      title: "Delete File",
      description: "Are you sure you want to delete this file?",
    });
    if (!res) return;

    const loadingId = loading.addLoading("deleting file");
    const proposalId = proposal.id;
    await service.deleteProposalFile({ id: proposalId, fileName });
    getFiles();
    loading.removeLoading(loadingId);
  };

  const downloadFile = async (fileName) => {
    const proposalId = proposal.id;
    var data = await service.downloadProposalFiles({
      id: proposalId,
      fileName,
    });
    if (!(data instanceof Blob)) {
      return;
    }
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}.pdf`;
    link.click();
  };

  useEffect(() => {
    getFiles();
  }, [getFiles, as]);
  return (
    <>
      <Grid container spacing={2}>
        <Grid container>
          <Typography variant="subtitle2">Upload Docs</Typography>
          <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
          <Typography style={{ color: "red" }} variant="caption">
            *Only PDF files can be uploaded
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <>
            {files.map((file) => (
              <FilesDisplayList
                key={`${file.name}`}
                filesCategory={file.category}
                fileName={file.name}
                files={file.files || []}
                uploadFile={uploadFile}
                deleteFile={deleteFile}
                downloadFile={downloadFile}
                disabled={!canEdit}
                multipleFiles={file.multiple}
              />
            ))}
          </>
        </Grid>
      </Grid>
    </>
  );
}
